<div class="color-button" (click)="stopPropagation($event)">
  <ion-button
    class="color-button__button --{{ size }}"
    [innerHTML]="'EVENT_RESPONSE.RESCHEDULE' | translate"
    (click)="clicked.emit()"
  ></ion-button>
</div>
